import { render, staticRenderFns } from "./FactoringNewThirdPartyListItem.vue?vue&type=template&id=dd0db0fc&lang=pug&"
import script from "./FactoringNewThirdPartyListItem.vue?vue&type=script&lang=js&"
export * from "./FactoringNewThirdPartyListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports